export default __webpack_public_path__ + "static/media/increase2.c052b06a.svg";